import { Mappable } from "models";

export interface HiredTeacherPlacements extends Mappable {
  bio: string;
  display: boolean;
  email?: string;
  firstName: string;
  major: string;
  gradYear: number;
  id: string;
  lastName: string;
  latitude: number;
  schoolAddress: string;
  longitude: number;
  // majors: string[];
  // minors?: string[];
  // phone?: string;
  photoUrl: string;
  currentPosition: string;
  district: string;
  quotes?: string[];
  schoolName: string;
  type: "hired";
  // wallID: string
}

export const emptyHiredPlacement: HiredTeacherPlacements = {
  bio: "",
  currentPosition: "",
  district: "",
  firstName: "",
  email: "",
  lastName: "",
  gradYear: 0,
  latitude: 0,
  display: true,
  longitude: 0,
  id: "",
  photoUrl: "",

  major: "",

  schoolAddress: "",
  // phone: "",
  // majors: [],
  // minors: [],
  quotes: [],
  schoolName: "",
  type: "hired",
};
